module.exports = __webpack_public_path__ + "static/img/evpg-btn.8a8d744.png";